import PropTypes from 'prop-types';
import DatalistInput from 'react-datalist-input';
import categoryList from '../utills/CategoryList';
import './option-dropdown.css';

const CategoryOptions = ({ value, onChange }) => (
  <div className="datalist-input-container">
    <DatalistInput
      placeholder="Select category"
      value={value}
      onSelect={(item) => onChange(item.value)}
      items={categoryList}
    />
  </div>
);

CategoryOptions.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CategoryOptions;
